import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { RiInstagramFill } from "react-icons/ri";
import { motion, useAnimation, useInView } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContactSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);
  const { t } = useTranslation();
  return (
    <Container>
      <motion.div
        ref={ref}
        className="left"
        animate={{ opacity: 1, x: 0 }}
        initial={{ opacity: 0, x: -200 }}
        transition={{
          duration: 0.7,
          bounce: 0.3,
          delay: 0.4,
          type: "spring",
        }}
      >
        <h1>{t("contactH1")}</h1>
        <p>{t("contactP")}</p>
        <Link
          className="link-styles"
          to={"https://www.instagram.com/bp11_artprint_kosova/"}
          target="_blank"
        >
          <RiInstagramFill className="icon" />
        </Link>
      </motion.div>
      <motion.form
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        transition={{
          duration: 0.7,
          delay: 0.8,
        }}
      >
        <h2>{t("contactUs")}</h2>
        <input type="text" name="name" placeholder={t("fullName")} required />
        <input
          type="phone"
          name="phoneNumber"
          placeholder={t("phoneNumber")}
          required
        />
        <textarea
          cols="20"
          rows="4"
          name="message"
          placeholder={t("message")}
          required
        ></textarea>
        <button type="submit">{t("send")}</button>
      </motion.form>
    </Container>
  );
};
const Container = styled.div`
  color: var(--fontPrimaryColor);
  background: var(--primaryBackgroundColor);
  padding: 7em 8%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-family: "Montserrat", cursive;
  position: relative;
  .left {
    margin-top: 5%;
    width: 45%;
    h1 {
      font-size: 4vw;
      line-height: 1.1em;
      font-weight: 400;
      span {
        color: var(--primaryColor);
      }
    }
    p {
      margin-right: 17%;
      color: var(--fontSecondaryColor);
      font-weight: 300;
      margin-top: 1em;
      max-width: 400px;
    }
    .icon {
      font-size: 3em;
      margin-top: 10px;
    }
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 1em;
    width: 700px;
    padding: 2em;
    h2 {
      font-weight: 300;
      text-align: center;
      margin-bottom: 10px;
    }
    input,
    textarea {
      font-family: "Montserrat", cursive;
      padding: 10px;
      font-size: 16px;
      border: none;
      border-bottom: 1px solid var(--fontSecondaryColor);
      background: none;
      color: var(--fontPrimaryColor);
      outline: none;
      ::placeholder {
        color: var(--fontSecondaryColor);
      }
    }
    button {
      margin-top: 1em;
      display: flex;
      align-self: flex-start;
      margin: auto;
      background: var(--fontPrimaryColor);
      border: none;
      color: var(--primaryBackgroundColor);
      padding: 17px;
      font-size: 18px;
      font-family: "Comfortaa", cursive;
      cursor: pointer;
      transition: 0.4s;
      :hover {
        box-shadow: 0 0 14px 2px var(--shadowColor);
      }
    }
  }
  @media (max-width: 1300px) {
    padding: 4em 7%;
    .left {
      h1 {
        font-size: 3em;
      }
    }
  }
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    .left {
      width: 100%;
      h1 {
        font-size: 3em;
      }
      p {
        text-align: center;
        margin: auto;
      }
    }
    form {
      width: 90%;
    }
  }
  @media (max-width: 550px) {
    padding: 6em 6% 4em 6%;
    form {
      width: 100%;
      padding: 10px;
    }
  }
  @media (max-width: 550px) {
    .left {
      h1 {
        font-size: 2.4em;
      }
    }
  }
  @media (max-width: 410px) {
    .left {
      h1 {
        font-size: 2em;
      }
    }
  }
`;

export default ContactSection;
